import React, { useState } from "react";
import { Button, Modal, Tooltip, Row, Tag, Space } from "antd";
import {
  UserAddOutlined,
  InfoOutlined,
  InfoCircleTwoTone,
} from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { actions as loginActions } from "views/Auth/Login/redux";
import { appTypeSelector } from "App/OfflineApp/offlineAppSelectors";
import { actions as fireStoreReduxActions } from "views/Experiences/ExperienceShow/FirestoreInteractions/redux";
import { WindowScroller } from "react-virtualized";
import { openUrl,isNewAppVersion,getAppVersion } from "lib/utils/helperMethods";
import { actions as offlineAppActions } from "App/OfflineApp/offlineAppRedux.js";


const LogoutBtn = (props) => {
  const dispatch = useDispatch();
  const appType = useSelector(appTypeSelector());
  let logoutBtn = "";
  const [loading, setLoading] = useState(false);
  const { experience } = props;

  const isMacOriOSApp = (appType === "mac" || appType === "ios");
  const isShowLogoutButton =  (appType === "seb" || isMacOriOSApp);

  const shouldDispatchChangeSecurity =
  isMacOriOSApp && experience.settings.mode == "offline";

  const currentAppVersion = getAppVersion(appType)
  const shouldRedirectToHomePage = true // redirect to home, if wanat to call openUrl("/")

  const handleLogoutButtonClick = (e) => {
    setLoading(true);
    props.withLog &&
      dispatch(
        fireStoreReduxActions.setUserInfo(
          {},
          {
            log: {
              logging: true,
              action: props.action
            },
          }
        )
      );
    logoutDispatch()
  };

  const logoutDispatch = () => {
    setTimeout(
      () => {
        dispatch(loginActions.logout({shouldDispatchChangeSecurity,shouldRedirectToHomePage}));
        setLoading(false);
      },
      props.withLog ? 1500 : 0
    );
  };

  if (isShowLogoutButton) {
    logoutBtn = (
      <Button
        loading={loading}
        danger
        ghost={true}
        onClick={() => {
          handleLogoutButtonClick();
        }}
      >
        Logout
      </Button>
    );
  }

  return logoutBtn;
};

export default LogoutBtn;